<template>
  <div style="display: flex;align-items: center;justify-content: center">
    <img src="@/assets/image/none.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'NothModal'
}
</script>

<style scoped>
img{
  width: 40%;
  margin-top: 45%;
}
</style>
